import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('platform', '/platforms')
const actions = generator.generate()

export default actions
